export const calculatePageSize = (count, filterStatePageSize) => {
  const pageSize = filterStatePageSize || process.env.REACT_APP_PAGE_SIZE;
  return Math.ceil(count / pageSize);
};
